import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetListDefaultOneilBrowserRequest extends BaseServiceRequest {
    constructor() {
        super();
        super.addRequestUri("defaultigoneilfilters.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "ListIGBrowserResponse";
    }
}
export default GetListDefaultOneilBrowserRequest;